import type { ReactNode } from "react";
import { FINANCE_PERMS } from "../lib/permissions";
import { RequirePerm } from "./RequirePerm";

/**
 * จอการเงินรวม — ต้องมี DSH-04/07/10 อย่างใดอย่างหนึ่ง (ADR-0030, `Actor.SeesFinanceStats`)
 * เป็นแค่การนำทาง: API ตอบ 403 ที่ /stats/fees กับ /admin/payments อีกชั้น
 */
export function RequireFinance({ children }: { children: ReactNode }) {
  return (
    <RequirePerm
      perm={FINANCE_PERMS}
      message="ລາຍງານການເງິນ ສຳລັບຕຳແໜ່ງທີ່ມີສິດເບິ່ງ Dashboard ການເງິນ ເທົ່ານັ້ນ"
      hint="ຜູ້ກວດເອກະສານ ເບິ່ງຄ່າທຳນຽມລາຍຄຳຮ້ອງໄດ້ທີ່ ຄິວຄຳຮ້ອງ"
    >
      {children}
    </RequirePerm>
  );
}
